import auth from './middleware/auth'
import Income from '@/screens/income'
import CashClosings from '@/screens/income/CashClosings'
import Collection from '@/screens/income/Collection'
import Billing from '@/screens/income/Billing'
import OtherMovements from '@/screens/expenses/OtherMovements'
import store from '@/store'

const routes = [
  {
    path: '/income',
    name: 'Income',
    component: {
      ...Income,
      beforeRouteUpdate (to, from, next) {
        if (to.name === 'Income') {
          const routes = {
            manager: 'CashClosings'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      },
      beforeRouteEnter (to, from, next) {
        if (to.name === 'Income') {
          const routes = {
            manager: 'CashClosings'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      }
    },
    meta: { requireAuth: true },
    children: [
      {
        path: 'cash-closings',
        name: 'CashClosings',
        component: CashClosings,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      },
      {
        path: 'movements',
        name: 'Movements',
        component: OtherMovements,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      },
      {
        path: 'collection',
        name: 'Collection',
        component: Collection,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      },
      {
        path: 'billing',
        name: 'Billing',
        component: Billing,
        meta: {
          requireAuth: true,
          permissions: ['manager'],
          middleware: { auth }
        }
      }
    ]
  }
]

export default routes
